import { isWeb, tva } from "@gluestack-ui/utils/nativewind-utils";

export const listStyle = tva({
  base: "list-disc flex flex-col",
  variants: {
    space: {
      "2xs": "gap-0.5",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-3",
      lg: "gap-4",
      xl: "gap-5",
      "2xl": "gap-6",
      "3xl": "gap-7",
      "4xl": "gap-8",
    },
    position: {
      inside: isWeb ? "list-inside" : "list-inside",
      outside: isWeb ? "list-outside ml-3" : "list-outside",
    },
  },
});
const itemBaseStyle = isWeb
  ? "list-item"
  : "list-item flex flex-row flex-wrap gap-x-2";

export const listItemStyle = tva({
  base: itemBaseStyle,
});
